import { render, staticRenderFns } from "./manifesto.vue?vue&type=template&id=486d6c18&scoped=true&"
import script from "./manifesto.vue?vue&type=script&lang=js&"
export * from "./manifesto.vue?vue&type=script&lang=js&"
import style0 from "./manifesto.vue?vue&type=style&index=0&id=486d6c18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d6c18",
  null
  
)

export default component.exports